import { ReferralsPortalProgramPayloadI } from './program.interfaces';

export class LoadReferralsProgram {
  public static type: string = '[HTTP] LoadReferralsProgram';
}

export class UpdateReferralsProgram {
  public static type: string = '[HTTP] UpdateReferralsProgram';
  constructor(public payload: ReferralsPortalProgramPayloadI) {}
}
